import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "block mb-4 px-2" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-left font-bold text-2xl" }, "Marketplace")
], -1)
const _hoisted_2 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4 px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RecommendationCard = _resolveComponent("RecommendationCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendations, (rec) => {
        return (_openBlock(), _createBlock(_component_RecommendationCard, {
          key: rec.id,
          recommendation: rec
        }, null, 8, ["recommendation"]))
      }), 128))
    ])
  ], 64))
}